import React from 'react';
import { Text, Pressable } from 'react-native';
import Colors from '../../constants/Colors';

type CountWidgetProps = {
  title: string;
  count: number;
  action: () => void;
  selected: boolean;
  extraPadding?: boolean;
  testID?: string;
};

const CountWidget: React.FC<CountWidgetProps> = ({
  title, count, action, selected, extraPadding = false, testID,
}) => (
  <Pressable onPress={action}
    style={(state) => [{
      flex: 1,
      marginRight: 6,
      borderWidth: 1,
      borderRadius: 8,
      borderColor: state.hovered ? Colors.light.hereworksBlue500 : 'transparent',
      padding: 8,
      backgroundColor: selected
        ? Colors.light.hereworksWhite500 : Colors.light.hereworksWhite100,
    }, extraPadding && { paddingRight: 44 }]}
    {...{ testID }}
  >
    <Text style={{
      color: Colors.light.hereworksBlack500,
      fontSize: 24,
      lineHeight: 24,
      fontFamily: 'Poppins_600SemiBold',
      marginLeft: 4,
    }}>
      {count}
    </Text>
    <Text style={[
      {
        fontSize: 12,
        marginTop: 8,
        fontFamily: 'Poppins_400Regular',
        color: selected ? Colors.light.hereworksBlue500
          : Colors.light.hereworksBlack200,
      },
    ]}>
      {title}
    </Text>
  </Pressable>
);

export default CountWidget;
